<template>
  <div class="mobileCourseDetail">
    <div class="browser_warp"
         @click="maskShow=false"
         v-show="maskShow">
      <div class="browser_bg"></div>
      <div class="open_browser_tips">
        <img src="/static/img/link_c.png">
      </div>
    </div>
    <header class="title">
      <i class="el-icon-arrow-left"></i>
      <span>
        课程详情
      </span>
    </header>
    <main>
      <div class="courseInfo"
           v-if="courseInfo">
        <img v-show="!player"
             :src="courseInfo.logoUrl || '/static/img/bitmap_en.png'">
        <div class="prism-player"
             id="J_prismPlayer"
             v-show="player"></div>
        <div class="course-about">
          <div class="price">
            ￥<span>{{courseInfo.currentPrice}}</span>
          </div>
          <h2 class="course-name">{{courseInfo.courseName}}</h2>
          <div class="about-info">
            课程有限期：{{courseInfo.loseType === '1' ? '购买之日起' + courseInfo.loseTime + '天' : courseInfo.endTime?courseInfo.endTime.slice(0, 10): ''}}
          </div>
          <div class="about-info quantity">
            <div>购买数 <font class="quantity-num">{{courseInfo.salesVolumes}} <font style="background-color:#eee;border-radius:0.2rem;padding:0.1rem;">次</font>
              </font>
            </div>
            <div>课时数 <font class="quantity-num">{{courseInfo.lessionNum}}<font style="background-color:#eee;border-radius:0.2rem;padding:0.1rem;">课</font>
              </font>
            </div>
            <div>浏览数 <font class="quantity-num">{{courseInfo.viewCount}}<font style="background-color:#eee;border-radius:0.2rem;padding:0.1rem;">次</font>
              </font>
            </div>
          </div>
        </div>
      </div>
      <div class="quantity tabar">
        <div class="bar-item"
             :class="{'bar-item-select':selectd==='detail'}"
             @click="selectd='detail'">课程详情</div>
        <div class="bar-item"
             :class="{'bar-item-select':selectd==='chapter'}"
             @click="selectd='chapter'">课程大纲</div>
        <div class="bar-item"
             :class="{'bar-item-select':selectd==='comment'}"
             @click="selectd='comment'">课程评论</div>
      </div>
      <div class="course-detail"
           v-show="selectd==='detail'">
        <div class="detail-title">
          <div class="top-bg"></div>
          <h2 class="tar-title">课程详情</h2>
        </div>
        <div class="detail-content"
             v-if="courseInfo&&courseInfo.courseContext"
             v-html="decodeURIComponent(courseInfo.courseContext)"></div>
      </div>
      <div class="course-detail"
           v-show="selectd==='chapter'">
        <div class="detail-title">
          <div class="top-bg"></div>
          <h2 class="tar-title">课程大纲</h2>
        </div>
        <div class="detail-content">
          <ul class="chapter">
            <li class="chapter-menu"
                v-for="item in courseChapter"
                :key="item.id">
              <div @click.stop="playVideo(item)">{{item.name}}</div>
              <ul v-if="item.childChapter">
                <li v-for="chapter in item.childChapter"
                    :key="chapter.id"
                    class="chapter-item">
                  {{chapter.name}}
                  <div @click.stop="playVideo(chapter)"
                       v-show='chapter.chapterType===2&&(chapter.free || !(courseInfo&&!courseInfo.bought))'
                       class="chapter-free">免费播放</div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="course-detail"
           v-show="selectd==='comment'">
        <div class="detail-title">
          <div class="top-bg"></div>
          <h2 class="tar-title">评论</h2>
        </div>
        <div class="detail-content">
          <div class="comment">
            <van-list v-model="loading"
                      :offset="0"
                      :finished="finished"
                      finished-text="没有更多了"
                      @load="getCommentList">
              <li v-for="(item, index) in commentList"
                  :key="index"
                  class="commendLi">
                <img :src="item.userAvatarURL">
                <div>
                  <p style="color: #262626; display: flex; width: 6rem;">
                    <span style="display: inline-block; flex: 1;">
                      {{item.userNickname}}
                      <span style="margin-left: 0.1rem; color: #666;">评论课程</span>
                    </span>
                    <span style="color: #999999; display:flex;justify-content:flex-end;">
                      <div class="comment-icon"></div>{{item.replyCount}}
                      <div class="comment-praise"></div>{{item.praiseCount}}
                    </span>
                  </p>
                  <div class="commendLi-content">
                    {{item.content}}
                  </div>
                  <div class="commendLi-time">
                    {{item.createTime}} <span class="commendLi-reply"
                          @click="changeShow(index)"> 回复</span>
                  </div>
                  <div class="commendLi-commend"
                       v-show="item.show===true">
                    <ul v-if="item.commentVos">
                      <li v-for="(commentVo, commentindex) in item.commentVos"
                          :key="commentindex"
                          class="commendLi">
                        <img :src="commentVo.userAvatarURL">
                        <div>
                          <p style="color: #262626; display: flex; width: 6rem;">
                            <span style="display: inline-block; flex: 1;">
                              {{commentVo.userNickname}}
                              <span style="margin-left: 0.1rem; color: #666;">评论课程</span>
                            </span>
                            <span style="color: #999999;">
                              <!-- <img src="/static/mobileImg/supportSimple.png" width="30" height="30"/> -->
                              <span class="comment-praise"></span>{{commentVo.praiseCount || 0}}
                            </span>
                          </p>
                          <div class="commendLi-content">
                            {{item.content}}
                          </div>
                          <div class="commendLi-time">{{commentVo.createTime}}</div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </van-list>
          </div>
        </div>
      </div>
      <div class="mainTeacher"
           v-show="selectd==='detail'">
        <div class="detail-title">
          <h2 class="tar-title">主讲讲师</h2>
        </div>
        <div class="teacher"
             v-for="item in teacherList"
             :key="item.id">
          <img class="teacher-img"
               :src="item.url|| '/static/img/bitmap_en.png'" />
          <div class="teacher-info">
            <div class="teacher-name">{{item.name}}<span style="font-size: 0.2rem; color: #666; margin-left:0.2rem;">{{item.education}}</span></div>
            <div class="teacher-instr">{{item.career}}</div>
          </div>
        </div>
      </div>
      <div class="mainTeacher"
           v-show="selectd==='detail'">
        <div class="detail-title">
          <h2 class="tar-title">学过此课程的人</h2>
        </div>
        <div style="display:flex;">
          <div class="student"
               v-for="item in courseStudyhistory"
               :key="item.id">
            <img class="student-img"
                 :src="item.userAvatarURL|| '/static/img/bitmap_en.png'" />
            <div class="student-name">{{item.userName}}</div>
          </div>
        </div>
      </div>
      <div class="mainTeacher"
           v-show="selectd==='detail'">
        <div class="detail-title">
          <h2 class="tar-title">猜你想学</h2>
        </div>
        <ul style="width: 100%;">
          <li v-for="item in maybeYouWant"
              :key="item.id"
              class="maybeYouWant-li">
            <div class="maybeYouWant-li-icon">&nbsp;</div>{{item.courseName}}
          </li>
        </ul>
      </div>
    </main>
    <footer @click.stop="jump">
      <div class="footer-item">加入购物车</div>
      <div class="footer-item footer-buy">立即购买</div>
      <!-- <div class="commendInput">我要回复...</div>
      <div class="fx" style="margin-right: 0.63rem;">
        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA9CAYAAADxoArXAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTcwODc2MkVDMzFGMTFFOTlBQ0FFNzg3MUI5QTgwN0IiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTcwODc2MkZDMzFGMTFFOTlBQ0FFNzg3MUI5QTgwN0IiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxNzA4NzYyQ0MzMUYxMUU5OUFDQUU3ODcxQjlBODA3QiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxNzA4NzYyREMzMUYxMUU5OUFDQUU3ODcxQjlBODA3QiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pj3q8TwAAASdSURBVHja7NtdaBxVFADgc+7MbmJd7J9RGrJN0lBBg2CJoP15krrmp320PhRUWktBo9ZUtPhQt30QUyiSGKX4U/XFB+OD2CwmaaXgXxVNKYW8tJjQ7KahUFNawia7M3OPZ2Zjs7MNoZKdv2XuS5K9k7vzzTn3zOydWYSi1pwcjWZvTDTqJLdLiS0Aci1IjCCigDI3BHkLUHyd7mv/DhxoTW8OPTCXM6KZ3rZJ3n9aeN/5Fu8crpWkHSakBHc3ghsNcVoRctdE784fyznshldSD+WBenj8GingxNZt7V/070LD7LMi13gwVS+l1g9A+13Dmo1oDWfSc+Ucsr5zqFFDOMkhbSWiFiGx+9xPqZeTSbKsouHA2VVaDr8EpC3gRSPONyIs13AG6ick0daFYyrXcCod/fz64OsWWDdmn+Wjsc0LKyvHKCJOFs+x5cxZCxhR3uKRL9gTiVZJMA7HXx1OYF1n6hS/sKO0ovAu/I6AGYk4B2Rg+aevMoUKfpvuaftzuWOZUzKfw3eUmDw08f6OG+teG2oRhv4ZUx+zbSjgPRN8icEb7UOIc1WxSNtY99M3wefNxGp5/IRTdzsBfqXG6OBttNQ/5fBumt/0N4yqO82J/KA9uKgJFY8ECitlAggEAr2gz+Dx9YcGVk/1PjMihbqPS8QId/yMSvTFzAet04Inzwp7rtEMGfJqoLC3J+udaFXQfhLRvZnexGVzE5VDrtqrJhc6RaXAYYvRaKHNv/Zc6ek4X1wUF72CIqljILFFaIY9bl6AlJ4BBASo3RW2cGr/iyQ8P/ZRx6XSPlGJWJSwb/LjjguL9auVhOX0HYElsIGI8P/Bchq/tBTW9+ByY30NdgLrW7BTWF+CncT6Duw01ldgN7C+AbuF9QXYTaznYLexnoK9wHoG9grrCdhLrOuflrzANnUNxfUc1Ughb6Y/bP9brWRsXdcP7bm8doQENPDHxum6zoFjroDN+1ZaXncVW39gcJ2R048RQDMUFnnu53fochxs3crRs4Mg6VE356xhQJwAawCKlrQINjpetKSca+EfD7tdoHjMLALZfAQUcb5KI+TuWAp2oRr78krLbaw7pyWDaPHAi4ug4J7JvraLbh5kx8FKFWWMHFxGwClrHhHHFODWypr63aPJ5hm3s8px8Pjxjit1bww+CXDfbCGyhcbYWS+mkSvnYfOunV8WGgJ1qyUEh+AQHIJDcAgOwSE4BIfgEOwzMAp/P4m3PDCibteC4ucn8e62WQa2lIRSFyzL2rfEGCqiNujgggFjttcQsmZKX7N5gSLSgL0b3j69MqhYc9+lTu8SUaSk69pST8T/gQLTknAOkIKR4oQkiKolUJwNT5gPmdojjAMqCDoFUrRy0qtFYTafo95MkjZbK/eBKWEEcuHX0kqs80H4Xqji3m+QZKrST0ecor+oyj39Vqqa3/XRQT8NRE2ViOWE/bWqmnabK6j2b6aB1s3H4ilO79qKgCKMc/kZFhg5mu5LXJ2P9EJrSJ6t1q7PbuHy/QhPhk38L2uJIOrEdw8dARJJ3vc8s/5Bhc6rKM6sWL1+fDTZnP9vm38FGABAzNvEDDniAwAAAABJRU5ErkJggg==">
        <p>评价</p>
      </div>
      <div class="fx" style="margin-right: 0.65rem;">
        <img src="data:image/png;base64,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">
        <p>收藏</p>
      </div>
      <div class="fx">
        <img src="data:image/png;base64,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">
        <p>分享</p>
      </div> -->
    </footer>
  </div>
</template>

<script>
import { setTimeout } from 'timers'
export default {
  data () {
    return {
      player: null,
      maskShow: false,
      commentCounts: 0,
      loading: false,
      finished: false,
      currentPage: 1,
      totalPage: null,
      courseInfo: null,
      courseChapter: [],
      teacherList: [],
      courseStudyhistory: [],
      maybeYouWant: [],
      commentList: [],
      selectd: 'detail'
    }
  },
  computed: {
    courseId () {
      return this.$route.query.id
    }
  },
  watch: {
    courseId (val) {
      if (this.val) {
        this.getCourseInfo()
        this.getCommentList()
      }
    }
  },
  created () {
    if (this.courseId) {
      this.getCourseInfo()
      this.getCommentList()
      // this.init()
      this.openApp()
    }
  },
  methods: {
    init () {
      let a = document.createElement('a')
      if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
        a.id = 'a'
        let json = {
          id: this.courseId,
          userId: this.$route.query.userId
        }
        a.href = `${window.SITE_CONFIG['iosAppUrl']}courseDetail?json=${encodeURIComponent(JSON.stringify(json))}`
        // document.body.appendChild(a)
        // 防止反复添加
        if (!document.getElementById('a')) {
          document.body.appendChild(a)
        }
        let e = document.createEvent('MouseEvent')
        e.initEvent('click', false, false)
        document.getElementById('a').dispatchEvent(e)
      } else if (navigator.userAgent.match(/android/i)) {
        // window.open(window.SITE_CONFIG['androidAppUrl'])
        a.setAttribute('href', `${window.SITE_CONFIG['androidAppUrl']}?type=courseDetail?id=${this.courseId}&userId=${this.$route.query.userId}`)
        a.setAttribute('target', '_blank')
        a.setAttribute('id', 'a')
        // 防止反复添加
        if (!document.getElementById('a')) {
          document.body.appendChild(a)
        }
        a.click()
      }
    },
    // 获取课程详情
    getCourseInfo () {
      this.courseInfo = null
      this.courseChapter = []
      this.teacherList = []
      this.courseStudyhistory = []
      this.maybeYouWant = []
      this.$http.get(`${window.SITE_CONFIG['trainURL']}/courseManagement/traincourse/courseInfo/${this.courseId}`)
        .then(data => {
          if (data && data.result && data.result.code === 0) {
            // this.isBan = false
            this.courseInfo = data.result.data.courseInfo
            this.courseChapter = data.result.data.courseChapter
            this.teacherList = data.result.data.teacherList
            this.courseStudyhistory = data.result.data.courseStudyhistory
            this.maybeYouWant = data.result.data.maybeYouWant
          } else {
            this.$message.error(data.result.msg)
            // this.isBan = true
          }
        })
        .catch(() => {
          // this.isBan = true
        })
    },
    // 获取评论列表
    getCommentList (currentPage = this.currentPage) {
      this.commentList = []
      this.totalPage = 0
      this.$http.get(`${window.SITE_CONFIG['trainURL']}/courseManagement/traincomment/listCourseCommentsAtDetailPage`,
        {
          params: {
            'page': currentPage,
            'limit': 5,
            'id': this.courseId
          }
        })
        .then(data => {
          if (data && data.result.code === 0) {
            this.commentList = data.result.data.data || []
            this.commentCounts = data.result.data.count || 0
            this.totalPage = Math.ceil((data.result.data.count || 0) / 5)
            if (this.currentPage >= this.totalPage) {
              this.finished = true
            }
          }
        })
        .catch(() => {
        })
    },
    changeShow (index) {
      this.commentList[index].show = true
    },
    jumpDownload () {
      let { isAndroid, isIOS, isIOS9 } = this.detectVersion()
      if (isAndroid) {
        window.location = window.SITE_CONFIG['androidUrl']
      } else if (isIOS || isIOS9) {
        window.location = window.SITE_CONFIG['iosUrl']
      }
    },
    onLoad () {
      let oldCurrent = this.currentPage
      this.currentPage = oldCurrent + 1
      if (this.currentPage <= this.totalPage) {
        this.$http.get(`${window.SITE_CONFIG['trainURL']}/courseManagement/traincomment/listCourseCommentsAtDetailPage`, { params: { page: this.currentPage, limit: 5, id: this.courseId } })
          .then(data => {
            let oldComment = this.commentList
            this.commentList = [...oldComment, ...data.result.data.data]
            this.loading = false
          })
      } else {
        this.finished = true
      }
    },
    getFIleCommend () {
      this.$http.get(`${window.SITE_CONFIG['forumURL']}/technicaldocumentation/technicalfilerepliypost/searchFileComments`, { params: { page: this.currentPage, limit: 5, fileRepliyId: this.$route.query.fileId } })
        .then(data => {
          setTimeout(() => {
            this.commentCounts = data.result.data.count
            this.commentList = data.result.data.data
            var page = Math.ceil(data.result.data.count / 5)
            this.totalPage = page
          }, 1500)
        })
    },
    jump () {
      let isWx = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
      if (isWx) {
        this.maskShow = true
      } else {
        // this.openApp()
        this.jumpDownload()
      }
    },
    detectVersion () {
      let isAndroid = false
      let isIOS = false
      let isIOS9
      let version
      let u = navigator.userAgent
      let ua = u.toLowerCase()
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { // android终端或者uc浏览器
        // Android系统
        isAndroid = true
      }
      if (ua.indexOf('like mac os x') > 0) {
        // ios
        // let regStr_saf = /os [\d._]*/gi ;
        let verinfo = ua.match(/os [\d._]*/gi)
        version = (verinfo + '').replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.')
      }
      let versionStr = version + ''
      if (versionStr !== 'undefined' && versionStr.length > 0) {
        version = parseInt(version)
        if (version >= 8) {
          // ios9以上
          isIOS9 = true
        } else {
          isIOS = true
        }
      }
      return { isAndroid, isIOS, isIOS9 }
    },
    // 判断手机上是否安装了app，如果安装直接打开url，如果没安装，执行callback
    openApp (url) { // , callback = this.jumpDownload
      let isWx = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
      if (isWx) {
        return false
      }
      let { isAndroid, isIOS, isIOS9 } = this.detectVersion()
      let json = {
        id: this.courseId,
        userId: this.$route.query.userId
      }
      if (isAndroid || isIOS) {
        if (isAndroid) {
          let a = document.createElement('a')
          a.setAttribute('href', `${window.SITE_CONFIG['androidAppUrl']}?type=courseDetail&id=${this.courseId}&userId=${this.$route.query.userId}`)
          a.setAttribute('target', '_blank')
          a.setAttribute('id', 'a')
          // 防止反复添加
          if (!document.getElementById('a')) {
            document.body.appendChild(a)
          }
          a.click()
        } else if (isIOS) {
          var ifr = document.createElement('iframe')
          ifr.setAttribute('src', `${window.SITE_CONFIG['iosAppUrl']}courseDetail?json=${encodeURIComponent(JSON.stringify(json))}`)
          ifr.setAttribute('style', 'display:none')
          document.body.appendChild(ifr)
        }
      }
      if (isIOS9) {
        // let t = 5000
        // let hasApp = true
        // setTimeout(function () {
        //   if (!hasApp) {
        //     callback && callback()
        //   }
        //   document.body.removeChild(ifr)
        // }, 5000)
        // let t1 = Date.now()
        location.href = `${window.SITE_CONFIG['iosAppUrl']}courseDetail?json=${encodeURIComponent(JSON.stringify(json))}`
        // setTimeout(function () {
        //   let t2 = Date.now()
        //   if (t2 - t1 < t + 4000) {
        //       hasApp = false;
        //   }
        // }, t);
        // setTimeout(function() {
        //     location.reload();
        // }, 1000);
      }
    },
    playVideo (data) {
      if (data.chapterType !== 2) {
        return false
      }
      let isWx = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
      if (isWx) {
        this.maskShow = true
        return true
      }
      if (data.chapterType === 2) {
        if ((this.courseInfo && (this.courseInfo.free || this.courseInfo.bought)) || data.free) {
          // 可以播放
          if (data.content) {
            this.getVideoInfo(data.content)
          }
        } else {
          this.$message.warning('请先购买')
        }
      }
    },
    getVideoInfo (vid) {
      this.$http.get(`${window.SITE_CONFIG['trainURL']}/alioss/sysossali/getVideoPlayAuthInfo?videoId=${vid}`)
        .then(data => {
          // console.log(data.result.data.playAuth, 'data.result.data.playAuth')
          if (data.result.code === 0) {
            if (this.player) {
              this.player.replayByVidAndPlayAuth(vid, data.result.data.playAuth)
            } else {
              this.player = new Aliplayer({
                id: 'J_prismPlayer',
                // width: '477px',
                autoplay: false,
                'isLive': false,
                'rePlay': false,
                'playsinline': true,
                'preload': true,
                'controlBarVisibility': 'hover',
                // 播放方式一：推荐
                prismType: 2,
                vid: vid,
                // accId: '',
                // accSecret: '',
                // apiKey: '',
                // vid: '68f5c1ec2cdc4fb9b668ac5b6f677f5a',
                playauth: data.result.data.playAuth,
                showBarTime: 3000000,
                cover: data.result.data.videoMeta.coverURL,
                // source: "http://cloud.video.taobao.com/play/u/2554695624/p/1/e/6/t/1/fv/102/28552077.mp4", // 视频地址
                skinLayout: [
                  { name: 'bigPlayButton', align: 'blabs', x: 30, y: 80 },
                  {
                    name: 'H5Loading', align: 'cc'
                  },
                  {
                    name: 'controlBar',
                    align: 'blabs',
                    x: 0,
                    y: 0,
                    children: [
                      // {name: "progress", align: "tlabs", x: 0, y: 0},   //隐藏进度条
                      { name: 'playButton', align: 'tl', x: 15, y: 13 },
                      { name: 'timeDisplay', align: 'tl', x: 10, y: 6 },
                      { name: 'fullScreenButton', align: 'tr', x: 20, y: 12.5 },
                      { name: 'volume', align: 'tr', x: 20, y: 12.5 }
                    ]
                  }
                ]
              })
            }
            document.getElementById('J_prismPlayer').scrollIntoView()
          } else {
            this.$message.error(data.result.msg)
            this.player = null
          }
        })
        .catch(() => {
          this.player = null
        })
    }
  },
  mounted () {
    // if (this.courseId) {
    //   this.getCourseInfo()
    //   this.getCommentList()
    // }
    // this.getFileInfo()
    // this.getRelatedInfo()
    // this.getFIleCommend()
  }
}
</script>

<style scoped>
.mobileCourseDetail {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.browser_warp {
  display: block;
}
.browser_bg {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #000;
  opacity: 0.8;
  z-index: 999;
}
.open_browser_tips {
  position: fixed;
  width: 100%;
  top: 0;
  right: 0;
  z-index: 9999;
}
.open_browser_tips img {
  width: 100%;
  border: 0;
  margin: 0;
  padding: 0;
}
main {
  flex: 1;
  overflow-y: auto;
}
.title {
  height: 0.88rem;
  font-size: 0.36rem;
  line-height: 0.88rem;
  text-align: center;
  border-bottom: 0.01rem solid #eeeeee;
}
.title i {
  float: left;
  font-size: 0.52rem;
  padding-left: 0.22rem;
  padding-top: 0.16rem;
}
.title span {
  margin-left: -0.72rem;
  color: #333333;
  letter-spacing: 0;
  font-family: PingFangSC-Medium;
  font-weight: 600;
}
.courseInfo {
  /* margin: 0 0.32rem; */
  /* height: 2.32rem; */
  border-bottom: 0.01rem solid #eeeeee;
  padding-top: 0.35rem;
}
.courseInfo img {
  width: 100%;
  height: 4.5rem;
}
.prism-player {
  width: 100%;
  height: 4.5rem;
}
.prism-player .prism-big-play-btn {
  /* width: 45px;
  height: 45px; */
  /* background-size: 128px 256px; */
}
.course-about {
  padding: 0.2rem 0.2rem;
}
.course-about .price {
  font-size: 0.4rem;
  color: #ec280b;
}
.course-about .price span {
  font-size: 0.7rem;
}
.course-about .course-name {
  color: #333333;
  font-size: 0.4rem;
}
.about-info {
  font-size: 0.3rem;
  /* letter-spacing: 0.1rem; */
  color: #999999;
  padding: 0.2rem 0;
}
.quantity {
  display: flex;
  /* height: 0.4rem; */
  padding-top: 0;
  justify-content: space-between;
}
.quantity .quantity-num {
  color: #1b6bb4;
}
.tabar {
  border-top: 0.2rem solid #eeeeee;
  border-bottom: 0.2rem solid #eeeeee;
  /* margin-top: 0.3rem; */
  padding: 0 0.5rem;
}
.bar-item {
  /* height: 0.4rem; */
  padding: 0.3rem 0;
  font-size: 0.28rem;
  color: #333;
}
.bar-item-select {
  color: #1b6bb4;
  border-bottom: 0.05rem solid #1b6bb4;
}
.course-detail {
  padding: 0.3rem 0.2rem;
  border-bottom: 0.3rem solid #eeeeee;
}
.detail-title {
  display: flex;
  padding-bottom: 0.2rem;
  /* background: #1d65a8 no-repeat fixed top; */
}
.detail-title .top-bg {
  width: 0.06rem;
  background-color: #1d65a8;
  margin-right: 0.2rem;
  /* margin-right: 10px; */
}
.tar-title {
  font-size: 0.28rem;
  font-weight: normal;
}
.detail-content {
  font-size: 0.28rem;
}
.detail-content img {
  max-width: 100%;
}
/* 章节 */
.chapter-menu {
  line-height: 0.4rem;
  font-size: 0.23rem;
  color: #333;
  padding-left: 0.2rem;
}
.chapter-menu:nth-child(even) {
  background: #eee;
}
.chapter-item {
  margin-bottom: 0.2rem;
  padding-left: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #666;
}
.chapter-free {
  flex-shrink: 0;
  color: #1b6bb4;
  padding: 0 0.3rem;
  border: 1px #1b6bb4 solid;
  border-radius: 0.2rem;
}
.comment {
  display: flex;
}
/* 主讲讲师 */
.mainTeacher {
  padding: 0.2rem 0.2rem;
  border-bottom: 0.3rem solid #eee;
}
.mainTeacher h2 {
  color: #333333;
}
.teacher {
  display: flex;
}
.teacher-img {
  width: 2rem;
  height: 2.4rem;
  margin-right: 0.3rem;
  flex-shrink: 0;
}
.teacher-info {
  overflow: hidden;
}
.teacher-name {
  font-size: 0.3rem;
  /* height: 0.4rem; */
  line-height: 0.4rem;
  color: #333;
}
.teacher-instr {
  font-size: 0.28rem;
  color: #666666;
  line-height: 0.4rem;
}
/* 学过此课程的人 */
.student {
  width: 1rem;
  margin: 0.05rem 0.25rem;
}
.student-img {
  width: 1rem;
  height: 1rem;
  border-radius: 0.5rem;
}
.student-name {
  text-align: center;
  color: #666;
  font-size: 0.24rem;
  line-height: 0.35rem;
}
/* 猜你想学 */
.maybeYouWant-li {
  display: flex;
  align-items: center;
  line-height: 0.4rem;
  color: #333333;
  font-size: 0.2rem;
  word-wrap: break-word;
  word-break: break-all;
}
.maybeYouWant-li-icon {
  width: 0.1rem;
  height: 0.1rem;
  margin-right: 0.13rem;
  line-height: 0.4rem;
  background: #1b6bb4;
  border-radius: 0.05rem;
  flex-shrink: 0;
}
/* 底 */
footer {
  height: 1.06rem;
  line-height: 1.04rem;
  display: flex;
  /* padding: 0 0.32rem;
  padding-top: 0.16rem; */
  border-top: 0.02rem solid #eeeeee;
}
.footer-item {
  font-size: 0.32rem;
  width: 50%;
  text-align: center;
  color: #1b6bb4;
}
.footer-buy {
  background: #1b6bb4;
  color: #fff;
}
.fileTitle {
  font-size: 0.3rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: bold;
  margin-bottom: 0.26rem;
}
.docOtherInfo {
  display: flex;
  font-size: 0.24rem;
  color: #262626;
}
.authorInfo {
  display: flex;
  margin-top: 0.1rem;
  color: #666666;
  line-height: 0.55rem;
  font-size: 0.24rem;
}
.authorInfo img {
  width: 0.55rem;
  height: 0.55rem;
}
.authorInfo p {
  text-indent: 0.13rem;
}
.docImgList {
  min-height: 5rem;
}
.docImgList img {
  width: 100%;
}
.detailDivide {
  height: 0.2rem;
  background: #f5f5f5;
}
.relatedDoc {
  padding: 0 0.32rem;
  width: 7.5rem;
  padding-bottom: 0.16rem;
}
.relatedDoc h3 {
  height: 1.11rem;
  line-height: 1.11rem;
  color: #333333;
  font-size: 0.35rem;
}
.van-swipe {
  width: 6.86rem;
  overflow: hidden;
}
.van-swipe__indicators {
  height: 0.1rem;
}
.staticLb {
  width: 0.3rem;
  height: 0.04rem;
  background: #d8d8d8;
}
.activeLb {
  width: 0.3rem;
  height: 0.04rem;
  background: #1d65a8;
}
.lbzs {
  display: flex;
  justify-content: center;
  width: 6.86rem;
  margin-top: 0.1rem;
}
.lbzs li {
  width: 0.3rem;
  margin-right: 0.1rem;
}
.relatedProduct {
  padding: 0 0.32rem;
  width: 7.5rem;
  padding-bottom: 0.16rem;
}
.relatedProduct h3 {
  height: 1.11rem;
  line-height: 1.11rem;
  color: #333333;
  font-size: 0.35rem;
}
.commend {
  width: 7.5rem;
  padding: 0 0.32rem;
  padding-bottom: 1rem;
}
.commendTitle {
  height: 1rem;
  line-height: 1rem;
  display: flex;
  border-bottom: 0.01rem solid #eeeeee;
}
.commendTitle h3 {
  flex: 1;
  color: #333333;
  font-size: 0.36rem;
}
.commendTItle p {
  color: #666666;
  font-size: 0.26rem;
}
.commendTitle p span {
  font-size: 0.3rem;
  color: #333333;
  font-weight: bold;
  display: inline-block;
  margin-top: -0.03rem;
}
.commendLi {
  min-height: 1.52rem;
  border-bottom: 0.01rem solid #eeeeee;
  padding-top: 0.32rem;
  display: flex;
}
.commendLi img {
  width: 1rem;
  height: 1rem;
  margin-right: 0.25rem;
}
.commendLi span {
  font-size: 0.26rem;
}
.comment-icon {
  width: 0.35rem;
  height: 0.28rem;
  background: url(/static/mobileImg/discuss.png) no-repeat 0 0.07rem;
  background-size: 0.24rem 0.24rem;
}
.comment-praise {
  margin: 0 0.15rem;
  width: 0.35rem;
  height: 0.29rem;
  background: url(/static/mobileImg/supportSimple.png) no-repeat 0 0.07rem;
  background-size: 0.24rem 0.24rem;
}
.commendLi-content {
  line-height: 0.28rem;
}
.commendLi-time {
  color: #999999;
  font-size: 0.22rem;
}
.commendLi-reply {
  color: #1d65a8;
}
.commendLi-commend {
  padding-left: 0.1rem;
}
.commendLi h4 {
  font-weight: normal;
  padding: 0.1rem 0;
}
.commendInput {
  width: 3.7rem;
  height: 0.74rem;
  line-height: 0.74rem;
  background: #f1f1f1;
  color: #aaaaaa;
  text-indent: 0.25rem;
  border-radius: 0.05rem;
  margin-right: 0.635rem;
  font-size: 0.26rem;
}
footer img {
  width: 0.43rem;
}
.fx {
  width: 0.43rem;
}
.fx p {
  font-size: 0.12rem;
  color: #666666;
  text-align: center;
  white-space: nowrap;
  padding-top: 0.06rem;
  margin-left: -0.04rem;
}
.doclist {
  display: flex;
}
.doclist li {
  width: 2.1rem;
  margin-right: 0.15rem;
}
.doclist li img {
  display: block;
  width: 1rem;
  margin: 0 auto;
}
.doclist li p {
  margin-top: 0.25rem;
  margin-bottom: 0.2rem;
  height: 0.24rem;
  line-height: 0.24rem;
  font-size: 0.24rem;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
